module.exports = __webpack_public_path__ + "4bd0e65f45ebe9bb21dd5970f1ef2834.jpg";